export default "__VITE_ASSET__BSiMejYJ__"